import csrfToken from './csrf_token';

// POST to /graphql from a Stimulus controller. The counterpart of `auto_save.js` for the
// mutations that have no Rails form behind them: it owns the CSRF header and the two ways
// GraphQL reports a failure — transport `errors`, and the `errors` array a mutation returns
// as part of its own payload — so callers only decide what to say about them.
//
//   import graphql from 'stimulus/graphql';
//
//   const { resource } = await graphql(MUTATION, { name }, 'createProposedTag');
//
// Resolves with the mutation's payload and rejects with an Error carrying the first message.

const GENERIC_ERROR = 'Oops, something went wrong.';

export default async function graphql(query, variables, path) {
  let body;

  try {
    const response = await fetch('/graphql', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': csrfToken()
      },
      body: JSON.stringify({ query, variables })
    });
    if (!response.ok) throw new Error(response.statusText);

    body = await response.json();
  } catch {
    throw new Error(GENERIC_ERROR);
  }

  if (body.errors?.length) throw new Error(GENERIC_ERROR);

  const payload = path ? body.data?.[path] : body.data;
  if (!payload) throw new Error(GENERIC_ERROR);

  if (payload.errors?.length) throw new Error(payload.errors[0].message || GENERIC_ERROR);

  return payload;
}
